
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#050606","stroke-linejoin":"round","stroke-miterlimit":"10","d":"M13.09 5.181H9.534A1.063 1.063 0 018.47 4.117V.777"}}),_c('path',{attrs:{"fill":"none","stroke":"#050606","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","d":"M4.283 8.168h6.435M4.283 11.154h6.435"}}),_c('path',{attrs:{"fill":"#050606","d":"M8.679 1.075l4.158 4.21.001 8.589a.05.05 0 01-.05.05H2.213a.051.051 0 01-.051-.05V1.126a.05.05 0 01.051-.051h6.466m.418-1H2.213c-.58 0-1.051.47-1.051 1.051v12.749c0 .579.471 1.05 1.051 1.05h10.575c.579 0 1.05-.471 1.05-1.05l-.001-9-4.74-4.8z"}})])
          )
        }
      }
    